import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import * as React from 'react';
import { EventParticipantsComponent, EventParticipantsComponentProps } from './eventParticipants';
import { EventBetsComponent, EventBetsComponentProps } from './eventBets';
import { EventScoresComponent, EventScoresComponentProps } from './scores1/eventScores';
import { EventScoreBoardsComponent, EventScoreBoardsComponentProps } from './scores2/eventScoreBoards';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      {...other}
    >
      {value === index && children}
    </div>
  );
}

function tabProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const UserAddInfoTabsComponent = (props: {
  // participants
  participantsProps: EventParticipantsComponentProps,
  // bets
  betsProps?: EventBetsComponentProps,
  // scores
  scoreProps?: EventScoresComponentProps,
  // scoreboards
  scoreBoardProps?: EventScoreBoardsComponentProps,
  // default
  style?: React.CSSProperties | undefined
}) => {
  const [currTab, setCurrTab] = React.useState(0);

  const onTabChange = (event: React.SyntheticEvent, newTabIndex: number) => {
    setCurrTab(newTabIndex);
  };

  return <Box sx={{ width: '100%', mt: 2 }} aria-label='UserAddInfoTabsComponent'>
    <Box sx={{ borderBottom: 1, borderColor: 'divider' }} aria-label='UserAddInfoTabsComponent-tabs'>
      <Tabs value={currTab} onChange={onTabChange} indicatorColor="primary" textColor="primary" variant="fullWidth">
        <Tab label="Participantes" {...tabProps(0)} />
        {props.betsProps?.eventId && <Tab label="Odds" {...tabProps(1)} />}
        {props.betsProps?.eventId && <Tab label="Resultados" {...tabProps(2)} />}
        {/* {props.scoreBoardProps?.event.id && <Tab label="Resultados 2" {...tabProps(3)} />} */}
      </Tabs>
    </Box>

    <TabPanel value={currTab} index={0}>
      <EventParticipantsComponent
        {...props.participantsProps}

        style={{
          width: '100%',
          ...props.participantsProps.style,
        }}
      />
    </TabPanel>

    {props.betsProps?.eventId && <TabPanel value={currTab} index={1}>
      <EventBetsComponent
        {...props.betsProps}

        style={{
          width: '100%',
          ...props.participantsProps.style,
        }}
      />
    </TabPanel>}

    {props.scoreBoardProps?.event.id && <TabPanel value={currTab} index={2}>
      <EventScoreBoardsComponent
        {...props.scoreBoardProps}
        style={{
          width: '100%',
          ...props.participantsProps.style,
        }}
      />
    </TabPanel>}

    {/* {props.betsProps?.eventId && <TabPanel value={currTab} index={3}>
      <EventScoresComponent
        {...props.scoreProps}

        style={{
          width: '100%',
          ...props.participantsProps.style,
        }}
      />
    </TabPanel>} */}



  </Box>
}